<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  /* min-width: 800px;
  min-height: 600px; */
  background-color: #f1f2f5;
  overflow-y: auto;
  overflow-x: auto;

  /* background-image: linear-gradient(#fff, #999999); */
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
/* ::-webkit-scrollbar {
  width: 0px;
  height: 0px;
} */
/* ::-webkit-scrollbar-button{
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  width: 0;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue